import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import {
  ColorPicker as ColorPickerProp1,
  colorList,
  convertOrigin,
  hexToRgba,
  sizeList,
} from "bodycodi/cmap/app/components/common/imageEditor/imageEditer";
import { isEmpty } from "../../../js/common";
import textDisable from "bodycodi/cmap/app/img/editor-text-disable.png";

const createArray = (rows: number, columns: number) => {
  const arr = new Array(rows);
  for (let i = 0; i < rows; i++) {
    arr[i] = new Array(columns);
  }
  return arr;
};

const TextControll = ({ color, setColor, editor, activeObject, setMode1 }: ColorPickerProp1) => {
  const [open, setOpen] = useState(false);
  const [openSize, setOpenSize] = useState(false);
  const [mode, setMode] = useState("picker");
  const canvas = useRef<HTMLCanvasElement>(null);
  const pickColor = useRef<HTMLDivElement>(null);
  const colrPicker = useRef<HTMLDivElement>(null);
  const sizePicker = useRef<HTMLDivElement>(null);
  const pickerBtn = useRef<HTMLDivElement>(null);
  const sisePickerBtn = useRef<HTMLDivElement>(null);
  const controller = useRef<HTMLDivElement>(null);
  const [pickFont, setPickFont] = useState({ fontSize: 14 });
  const wrap = useRef<HTMLDivElement>(null);
  const [imageData, setImageData] = useState("");

  function degToRad(deg: any) {
    return (Math.PI / 180) * deg;
  }

  useLayoutEffect(() => {
    const ctx = canvas.current!.getContext("2d")!;
    const geom = {
      x: 20,
      y: 20,
      radius: 16,
      statrAngle: 0,
      endAngle: 360,
      anticlockwise: false,
    };

    const part = 12;
    const eachDeg = 30;

    for (let i = 0; i < part; i++) {
      // arc(x, y, radius, startAngle, endAngle, anticlockwise)
      ctx.beginPath();
      ctx.strokeStyle = colorList[i];
      ctx.arc(
        geom.x,
        geom.y,
        geom.radius,
        degToRad(i * eachDeg),
        degToRad(i * eachDeg + eachDeg),
        geom.anticlockwise
      );
      ctx.lineWidth = 4;
      ctx.stroke();
    }
    ctx.closePath();

    document.addEventListener("click", handleOutSideClickPicker);
    document.addEventListener("click", handleOutSideClick);
    document.addEventListener("click", handleOutSideClickPickerSize);

    return () => {
      document.removeEventListener("click", handleOutSideClickPicker);
      document.removeEventListener("click", handleOutSideClick);
      document.removeEventListener("click", handleOutSideClickPickerSize);
    };
  }, []);

  useEffect(() => {
    pickColor.current!.style.transform = "scale(0)";
    pickColor.current!.style.webkitTransform = "scale(0)";
    pickColor.current!.style.transition =
      "transform 0.1s ease, -webkit-transform 0.1s ease, background-color 100ms ease";
    const position = convertOrigin(colorList.indexOf(color));
    setTimeout(() => {
      pickColor.current!.style.transformOrigin = `${position.x + 20}px ${position.y + 20}px`;
      pickColor.current!.style.transform = "scale(1)";
      pickColor.current!.style.backgroundColor = color;
    }, 150);
    editor.changeTextStyle(activeObject.id, {
      fill: color,
      fontSize: pickFont.fontSize,
    });
  }, [color]);

  useEffect(() => {
    wrap.current?.classList.add("open");
    //setImageData(editor.toDataURL());
  }, []);

  useEffect(() => {
    editor.changeTextStyle(activeObject.id, {
      fill: color,
      fontSize: pickFont.fontSize,
    });
  }, [pickFont]);

  const setColorPicker = (d: string) => () => {
    setColor(d);
  };

  const setSizePicker = (d: any) => () => {
    setPickFont(d);
  };

  const colorListComponents = colorList.map((d: string) => {
    return <div className="color" style={{ backgroundColor: d }} onClick={setColorPicker(d)}></div>;
  });

  const sizeListComponents = sizeList.map((d: any) => {
    const lineColor = d.fontSize === pickFont.fontSize ? "#ffffff" : "#000000";
    const lineColor1 = d.fontSize === pickFont.fontSize ? "#000000" : "#ffffff";
    const styles: any = { color: lineColor, fontSize: d.fontSize + "px", fontFamily: "Medium" };
    let rgba: any;
    if (!isEmpty(lineColor)) {
      rgba = hexToRgba(lineColor, 0.1);
    }
    if (!isEmpty(color)) {
      if (d.fontSize === pickFont.fontSize) {
        styles.backgroundColor = lineColor1;
      }
    }
    return (
      <div className="fontSize" style={styles} onClick={setSizePicker(d)}>
        가
      </div>
    );
  });

  const openColorPicker = () => {
    setOpen(!open);
    setMode("picker");
  };

  const openSizePicker = () => {
    setOpenSize(!openSize);
    setMode("sizePicker");
  };

  const handleOutSideClickPicker = (e: any) => {
    const node = colrPicker.current!;
    const btn = pickerBtn.current!;

    if ((!node || !node.contains(e.target)) && !btn.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleOutSideClickPickerSize = (e: any) => {
    const node = sizePicker.current!;
    const btn = sisePickerBtn.current!;

    if ((!node || !node.contains(e.target)) && !btn.contains(e.target)) {
      setOpenSize(false);
    }
  };

  const handleOutSideClick = (e: any) => {
    const node = controller.current!;
    const canvas = document.querySelector(".tui-image-editor-canvas-container");
    const picker = colrPicker.current;
    const sizePicker1 = sizePicker.current;

    if (
      (!node || !node.contains(e.target)) &&
      !canvas?.contains(e.target) &&
      !picker?.contains(e.target) &&
      !sizePicker1?.contains(e.target)
    ) {
      editor.stopDrawingMode();
    }
  };

  const close = () => {
    wrap.current?.classList.remove("open");
    wrap.current?.classList.add("close");
    editor.stopDrawingMode();
    /*editor.loadImageFromURL(imageData, 'SampleImage').then(function (result :any) {
            editor.clearUndoStack();
            editor.clearRedoStack();
            editor._clearHistory();
        });*/
    setTimeout(() => {
      setMode1("");
    }, 100);
  };

  const clicConfirm = () => {
    wrap.current?.classList.remove("open");
    wrap.current?.classList.add("close");
    editor.stopDrawingMode();
    setTimeout(() => {
      setMode1("");
    }, 100);
  };

  return (
    <div className="custon-editor-feature-detail-wrap" ref={wrap}>
      <div className="custon-editor-feature-detail">
        <div className="color-picker-wrap" ref={controller}>
          {open && (
            <ColorPicker
              colrPicker={colrPicker}
              colorList={colorList}
              setColorPicker={setColorPicker}
            />
          )}
          {openSize && (
            <div className="color-picker-pop size-picker" ref={sizePicker}>
              {sizeListComponents}
            </div>
          )}
          <div className="color-picker" onClick={openColorPicker} ref={pickerBtn}>
            <canvas ref={canvas} width={40} height={40} />
            <div className="pick-color" ref={pickColor}></div>
          </div>
          <div
            className={"btn-color-picker eraser" + (mode === "sizePicker" ? " active" : "")}
            onClick={openSizePicker}
            ref={sisePickerBtn}
            style={{ fontSize: "0px" }}
          >
            <img src={textDisable} />
          </div>
        </div>
      </div>
    </div>
  );
};

type ColorPickerProp = {
  colrPicker: any;
  colorList: Array<any>;
  setColorPicker: Function;
};

const ColorPicker = ({ colrPicker, colorList, setColorPicker }: ColorPickerProp) => {
  const [colorList2d, setColorList2d] = useState<any>([]);

  useEffect(() => {
    let colorList2d1;
    const width = colrPicker.current!.clientWidth - 40;
    const length = Math.floor(width / 52);
    const left = colorList.length % length;
    const rows = Math.ceil(colorList.length / length);
    colorList2d1 = createArray(rows, length);
    for (let i = 0; i < colorList.length; i++) {
      const data = colorList[i];
      const rowIndex = Math.floor(i / length);
      const index = i % length;
      colorList2d1[rowIndex][index] = { color: data, empty: false };
    }
    for (let i = colorList.length; i < length * rows; i++) {
      const rowIndex = Math.floor(i / length);
      const index = i % length;
      colorList2d1[rowIndex][index] = { empty: true };
    }

    setColorList2d([...colorList2d1]);
    console.log(colorList2d1);
  }, []);

  const colorListComponents = colorList2d.map((d: any) => {
    const color = d.map((d1: any) => {
      if (!d1.empty) {
        return (
          <div
            className="color"
            style={{ backgroundColor: d1.color }}
            onClick={setColorPicker(d1.color)}
          ></div>
        );
      } else {
        return <div className="empty"></div>;
      }
    });
    return <div className="color-wrap">{color}</div>;
  });

  return (
    <div className="color-picker-pop" ref={colrPicker}>
      {colorListComponents}
    </div>
  );
};

export default TextControll;
